import {
    clearFavouritesStore,
    clearInspirationsStore,
    subscribeFavourites,
    subscribeInspirations,
} from 'helpers/store';
import {
    publish,
    UPDATE_FAVOURITES,
    UPDATE_INSPIRATIONS,
} from 'helpers/pubsub';
import initDualCurrency from './dual-currency/init';
import { country, language } from 'utils/settings';

function initPublicApi() {
    initDualCurrency();
    /**
     * Whenever the stored data is updated, we publish a pubsub event
     */
    subscribeFavourites(d => publish(UPDATE_FAVOURITES, d));
    subscribeInspirations(d => publish(UPDATE_INSPIRATIONS, d));
    /**
     *  When a user leaves certain pages we need to clear the store, since it likely contains outdated information.
     * Example pages:
     *  - the login page, where another account might now be used
     */
    const clearStorePaths = [
        `/${country}/${language}/profile`,
        `/${country}/${language}/login`,
    ];
    if (clearStorePaths.some(path => window.location.pathname.includes(path))) {
        window.addEventListener('beforeunload', function () {
            clearInspirationsStore();
            clearFavouritesStore();
        });
    }
}

export default initPublicApi;
